module.exports = __webpack_public_path__ + "img/g-logo-white.346446a3.png";